import script from "./ManageBrandCreateEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageBrandCreateEdit.vue?vue&type=script&setup=true&lang=js"

import "./ManageBrandCreateEdit.vue?vue&type=style&index=0&id=9ac4c4b0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ac4c4b0"]])

export default __exports__